// extracted by mini-css-extract-plugin
export default {"root":"SignOutButton_root__kgsN0"};